// 防抖
export default {}.install = (Vue, options = {}) => {
  let delayTime
  let timer
  let globalHandleEvent
  Vue.directive('repeatClick', {
    inserted (el, binding) {
      delayTime = binding.value.delay || 1000
      timer = null
      let handleEvent = () => {
        if (timer !== null) {
          // console.log('连续点击');
          clearTimeout(timer)
        }
        let canSend = !timer // 第一次 先发送一次

        timer = setTimeout(() => {
          timer = null
        }, delayTime)
        if (canSend) {
          binding.value.params = binding.value.params || []
          binding.value.event(...binding.value.params)
        }
      }
      globalHandleEvent = handleEvent
      el.addEventListener('click', handleEvent)
    },
    unbind (el) {
      try {
        el.removeEventListener('click', globalHandleEvent)
      } catch {}
    }
  })
}
